<template>
    <div>
        <h1>{{ $t("settings.system.openAi.header") }}</h1>

        <b-form-group
            v-if="canEnableOpenAi"
            :description="$t('settings.system.openAi.toggle.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="toggle-chatgpt"
            :label="$t('settings.system.openAi.toggle.label')"
        >
            <b-form-checkbox id="toggle-chatgpt" v-model="customerSettings.openAiEnabled" switch></b-form-checkbox>
        </b-form-group>

        <b-form-group
            id="fieldset-openai-api-key"
            :description="$t('settings.system.openAi.api-key.label')"
            :label="$t('settings.system.openAi.api-key.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="openai-api-key"
        >
            <b-form-input id="openai-api-key" v-model="customerSettings.openAiApiKey" />
        </b-form-group>
    </div>
</template>
<script>
import { BFormGroup, BFormInput, BFormCheckbox } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useCustomersStore } from "@/store/useCustomersStore";

export default {
    components: {
        BFormInput,
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        canEnableOpenAi: {
            required: true,
        },
    },
    setup({ canEnableOpenAi }) {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());

        if (canEnableOpenAi) {
            editableCustomerSettings.value.push("openAiEnabled");
        }

        return {
            customerSettings,
        };
    },
};
</script>
